import { render, staticRenderFns } from "./unilateralConsumption.vue?vue&type=template&id=0ac06872&scoped=true"
import script from "./unilateralConsumption.vue?vue&type=script&lang=js"
export * from "./unilateralConsumption.vue?vue&type=script&lang=js"
import style0 from "./unilateralConsumption.vue?vue&type=style&index=0&id=0ac06872&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac06872",
  null
  
)

export default component.exports